/**
 * PromoNotice — the promo verdict box (applied green / refused amber), the
 * ONE home for its styling. `PromoCodeDisclosure` renders its notes through
 * it, and web-portal-2's checkout steps re-export it for their step-owned
 * refusal notices — previously two hand-copied class strings that had
 * already started to drift.
 *
 * NativeWebFirst: state rides data-* + CSS selectors, not a JS class pick.
 * `data-reason` doubles as the e2e assertion target so specs never match
 * member-facing copy.
 */

import type { ReactNode } from 'react'

export interface PromoNoticeProps {
  variant: 'applied' | 'refused'
  /** Machine refusal reason (`promotion.reason`) — an e2e hook, never copy. */
  reason?: string
  children: ReactNode
  testId: string
}

export function PromoNotice({ variant, reason, children, testId }: PromoNoticeProps) {
  return (
    <div
      data-variant={variant}
      data-reason={reason}
      className="rounded-lg border p-3 text-sm
        data-[variant=applied]:border-green-200 data-[variant=applied]:bg-green-50 data-[variant=applied]:text-green-800
        data-[variant=refused]:border-amber-200 data-[variant=refused]:bg-amber-50 data-[variant=refused]:text-amber-800"
      role="status"
      data-testid={testId}
    >
      {children}
    </div>
  )
}
